<script>
import {
  CdrText, CdrImg, CdrGrid, CdrLink,
} from '@rei/cedar';
import formatContentAuthor from '../../../utils/formatContentAuthor';

export default {
  name: 'BioCard',
  components: {
    CdrText,
    CdrImg,
    CdrGrid,
    CdrLink,
  },
  props: {
    bio: {
      type: Object,
      required: false,
      default: null,
      validator: (obj) => {
        const isStr = (str) => typeof (str) === 'string';
        const propValidation = [
          isStr(obj.firstName),
          isStr(obj.lastName),
        ];
        return propValidation.reduce((sum, value) => sum && value);
      },
    },
  },
  data: () => ({
    baseClassName: 'contributor-card-details',
  }),
  computed: {
    displayAuthor() {
      return formatContentAuthor(this.bio);
    },
  },
};
</script>

<template>
  <cdr-grid
    v-if="bio"
    :class="`${baseClassName}`"
  >
    <cdr-img
      v-if="bio.image"
      :src="bio.image"
      radius="circle"
      ratio="1/1"
      fit="cover"
      position="top center"
      :class="`${baseClassName}__image`"
      :alt="`Photo of ${bio.firstName} ${bio.lastName}`"
    />
    <div
      :class="`${baseClassName}__content`"
    >
      <cdr-link
        :class="`${baseClassName}__name`"
        :href="bio.slug"
        modifier="standalone"
      >
        {{ displayAuthor }}
      </cdr-link>

      <cdr-text :class="`${baseClassName}__copy`">
        <em>
          {{ bio.briefBiography }}
        </em>
      </cdr-text>
    </div>
  </cdr-grid>
</template>

<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

  $baseClassName: 'contributor-card-details';

.#{$baseClassName} {
  grid-column: span 2;
  @include  cdr-sm-mq-up {
    grid-column: span 1;
  }

  grid-template-columns: 1fr 1fr 1fr 1fr;
  .#{$baseClassName}__image {
    grid-column: 1 / span 1;
    width: 100%;
  }
  .#{$baseClassName}__content {
    grid-column: 2 / span 3;
  }
  .#{$baseClassName}__name {
    @include cdr-text-heading-sans-300;
    color: $cdr-color-text-primary;
    margin-bottom: $cdr-space-half-x;
  }
  .#{$baseClassName}__copy {
    @include cdr-text-utility-sans-200;
    color: $cdr-color-text-secondary;
  }
}
</style>
